export const ANDGLE_INCREMENT_SMALL = 20
